import { Panel, Label } from '@uhg-harmony/uitk-react';
import { Arrow } from 'builder/scenes/SiteBuilder/SettingsPanel/SettingsPanel';
import {
  SizeLocationData,
  WidgetSizeLocation,
} from '../../../../builder/components/WidgetSizeLocation';
import { Config } from './types';
import {
  Background,
  BackgroundData,
} from 'builder/components/WidgetConfigurations/Background/Background';
import { Border } from 'builder/components/WidgetConfigurations/Border';
import {
  SizeLocationPanel,
  StyledPanel,
  StyledPanelTitle,
} from '../../Text/TextWidgetControl';
import TextInputPanel from 'builder/components/WidgetConfigurations/TextInput/TextInputPanel';
import styled from 'styled-components';

export const TextInputPanelWrapper = styled(StyledPanel)`
  & button[class^='Panelcomponent__HeaderSection'] {
    height: 2.5em;
    background: rgba(141, 145, 160, 0.07);
    border-radius: 0;
    &:hover,
    &:focus {
      box-shadow: none;
    }
  }
  & span[class^='Panelcomponent__HeaderMainContent'] {
    height: 2.5em;
  }
  & div[class^='uitk-panel Panelcomponent__Panel'] {
    margin-bottom: 0;
    border: none;
  }
  & div[class^='Panelcomponent__Content'] {
    padding: 1rem 2rem 1rem 1rem;
  }
`;

const TextInputWidgetControl: React.FC<WidgetControlProps<Config>> = (
  props: WidgetControlProps<Config>
) => {
  const {
    value,
    onChange,
    widgetState,
    site,
    saveSite,
    updateSite,
    currentPage: { layoutLocked },
  } = props;

  const updateWidgetSizeLocation = (sizeLoc: SizeLocationData) => {
    onChange({
      ...value,
      width: sizeLoc.width,
      height: sizeLoc.height,
      xLocation: sizeLoc.xLocation,
      yLocation: sizeLoc.yLocation,
      uniqueId: sizeLoc.uniqueId,
    });
  };

  const updateBackgroundData = (data: BackgroundData) => {
    onChange({
      ...value,
      backgroundData: data,
    });
  };

  const updateBackgroundImage = (data: Image) => {
    onChange({
      ...value,
      backgroundImage: data,
    });
  };

  const updateBorderData = (data: BorderData) => {
    onChange({
      ...value,
      borderData: data,
    });
  };

  const handleLineColor = (data: string) => {
    onChange({
      ...value,
      lineColor: data,
    });
  };

  const handleBackgroundColor = (data: string) => {
    onChange({
      ...value,
      backgroundData: {
        ...value.backgroundData,
        color: data,
      },
    });
  };

  const handleFieldRequirement = (data: boolean) => {
    onChange({
      ...value,
      required: data,
    });
  };

  const handleFieldLabel = (data: string) => {
    onChange({
      ...value,
      label: data,
    });
  };

  const handleValidationChange = (data: string) => {
    onChange({
      ...value,
      validation: data,
    });
  };

  const handlePlaceHolder = (data: string) => {
    onChange({
      ...value,
      placeholder: data,
    });
  };

  return (
    <>
      <Panel.Group>
        <TextInputPanelWrapper>
          <Panel
            title={<Label style={StyledPanelTitle}>General</Label>}
            icon={Arrow}
            data-test-id="textinput-general-panel"
          >
            <TextInputPanel
              data-test-id="text-input-panel"
              handleFieldRequirement={handleFieldRequirement}
              handleFieldLabel={handleFieldLabel}
              handleFieldValidation={handleValidationChange}
              handlePlaceholderLabel={handlePlaceHolder}
              widgetState={widgetState}
            />
          </Panel>
        </TextInputPanelWrapper>
        <StyledPanel>
          <SizeLocationPanel
            title={<Label style={StyledPanelTitle}>Size and Location</Label>}
            initiallyClosed
            icon={Arrow}
            data-test-id="authentication-panel"
          >
            <WidgetSizeLocation
              data-test-id="widget-size-location"
              disabled={layoutLocked}
              sizeLocation={{
                xLocation: value.xLocation,
                yLocation: value.yLocation,
                width: value.width,
                height: value.height,
                uniqueId: value.uniqueId,
              }}
              updateWidgetSizeLocation={updateWidgetSizeLocation}
              activeWidgetId={widgetState.id}
            />
          </SizeLocationPanel>
        </StyledPanel>
        <StyledPanel>
          <Panel
            title={<Label style={StyledPanelTitle}>Background</Label>}
            initiallyClosed
            icon={Arrow}
            data-test-id="provisioning-service-panel"
          >
            <Background
              data-test-id="background-component"
              disabled={layoutLocked}
              backgroundData={updateBackgroundData}
              backgroundImage={updateBackgroundImage}
              handleLineColor={handleLineColor}
              handleBackgroundColor={handleBackgroundColor}
              widgetState={widgetState}
              site={site}
              updateSite={updateSite}
              saveSite={saveSite}
            />
          </Panel>
        </StyledPanel>
        <StyledPanel>
          <Panel
            title={<Label style={StyledPanelTitle}>Border</Label>}
            initiallyClosed
            icon={Arrow}
          >
            <Border
              data-test-id="border-data"
              updateBorderData={updateBorderData}
              disabled={layoutLocked}
              handleLineColor={handleLineColor}
              widgetState={widgetState}
              pages={props.pages}
              site={props.site}
              updateSite={props.updateSite}
              saveSite={props.saveSite}
            />
          </Panel>
        </StyledPanel>
      </Panel.Group>
    </>
  );
};

export default TextInputWidgetControl;
